<!-- For CPG -->
<div class="row pt-2 pb-2 bg-white" *ngIf="module == 'CPG'">

  <div class="col-12 col-md-3 mt-2 mb-2">
    <span class="step-outer" (click)="onStepClick(1)">
      <span [ngClass]="step >= 1 ? 'step-number bg-secondary' : 'step-number'">1</span>
      <span [ngClass]="step >= 1 ? 'step-label text-muted fw-bold' : 'step-label text-muted'">
        Select Products
        <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Select one or more products for the coupon."
          placement="top">
        </i-bs>
      </span>
    </span>
  </div>

  <div class="col-12 col-md-3 mt-2 mb-2">
    <span class="step-outer" (click)="onStepClick(2)">
      <span [ngClass]="step >= 2 ? 'step-number bg-secondary' : 'step-number'">2</span>
      <span [ngClass]="step >= 2 ? 'step-label text-muted fw-bold' : 'step-label text-muted'">
        Build Coupon
        <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Add coupons type, title, description & image."
          placement="top">
        </i-bs>
      </span>
    </span>
  </div>

  <div class="col-12 col-md-3 mt-2 mb-2">
    <span class="step-outer" (click)="onStepClick(3)">
      <span [ngClass]="step >= 3 ? 'step-number bg-secondary' : 'step-number'">3</span>
      <span [ngClass]="step >= 3 ? 'step-label text-muted fw-bold' : 'step-label text-muted'">
        Select Retailers
        <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Pick one or more retailers."
          placement="top">
        </i-bs>
      </span>
    </span>
  </div>

  <div class="col-12 col-md-3 mt-2 mb-2">
    <span class="step-outer" (click)="onStepClick(4)">
      <span [ngClass]="step >= 4 ? 'step-number bg-secondary' : 'step-number'">4</span>
      <span [ngClass]="step >= 4 ? 'step-label text-muted fw-bold' : 'step-label text-muted'">
        Coupon Details
        <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Pick stores and add coupons start date, end date, quantity per transaction & max redemptions count."
          placement="top">
        </i-bs>
      </span>
    </span>
  </div>

</div>

<!-- For Retailer -->
<div class="row pt-2 pb-2 bg-white" *ngIf="module == 'RETAILER'">

  <div class="col-12 col-md-4 mt-2 mb-2">
    <span class="step-outer" (click)="onStepClick(1)">
      <span [ngClass]="step >= 1 ? 'step-number bg-secondary' : 'step-number'">1</span>
      <span [ngClass]="step >= 1 ? 'step-label text-muted fw-bold' : 'step-label text-muted'">
        Select Products
        <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Select one or more products for the coupon."
          placement="top"></i-bs>
      </span>
    </span>
  </div>

  <div class="col-12 col-md-4 mt-2 mb-2">
    <span class="step-outer" (click)="onStepClick(2)">
      <span [ngClass]="step >= 2 ? 'step-number bg-secondary' : 'step-number'">2</span>
      <span [ngClass]="step >= 2 ? 'step-label text-muted fw-bold' : 'step-label text-muted'">
        Build Coupon
        <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Add coupons type, title, description & image."
          placement="top">
        </i-bs>
      </span>
    </span>
  </div>

  <div class="col-12 col-md-4 mt-2 mb-2">
    <span class="step-outer" (click)="onStepClick(3)">
      <span [ngClass]="step >= 3 ? 'step-number bg-secondary' : 'step-number'">3</span>
      <span [ngClass]="step >= 3 ? 'step-label text-muted fw-bold' : 'step-label text-muted'">
        Coupon Details
        <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Pick stores and add coupons start date, end date, quantity per transaction & max redemptions count."
          placement="top">
        </i-bs>
      </span>
    </span>
  </div>

</div>
